import React from 'react';
import PropTypes from 'prop-types';

const HeaderRow = ({ children, className }) => (
  <thead className={className}>
    <tr>
      {children}
    </tr>
  </thead>
);

HeaderRow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

HeaderRow.defaultProps = {
  className: '',
};

export default HeaderRow;
